console.log('Welcome to side office 2 !')

$('.js-scroll-btn').on('click', function () {

  $('html, body').animate({
    scrollTop: $('.js-to-scroll').offset().top
  }, 500);
});
